var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"monitoringLogs"},[_c('label',[_vm._v("Logs")]),_c('ul',_vm._l((_vm.logs),function(log,index){return _c("log",{key:index,tag:"log",attrs:{"data":log}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }